<ion-button
  fill="outline"
  size="small"
  [disabled]="isOffline()"
  (click)="assignDriverAndVehicles()"
  libClickStopPropagation
>
  <ion-icon
    slot="start"
    aria-hidden="true"
    src="../assets/material-symbols/local_shipping_24dp.svg"
  ></ion-icon>
  {{ (mode() === 'modify' ? 'general.modify' : 'general.assign') | translate }}
</ion-button>
